export const ACTIVITY_TIMEOUT_DURATION = 2400000; //  40 minutes

export const DEFAULT_REMOVE_LABEL = '(-)';
export const DEFAULT_ADD_LABEL = '(+)';

export const TOKEN_ISSUE_TIME_KEYNAME = 'token_issue_time';
export const TOKEN_EXPIRE_TIME_KEYNAME = 'token_expire_time';

export const ORDER_CONFIRMATION_NUMBER_FIELDS = [
  'id',
  'brand',
  'factory_1',
  'factory_2',
  'sales_price',
  'cost_price',
  'critical_path',
  'duty_tariff',
  'transport',
  'blank_garment',
  'labels_other',
  'print',
  'embellishments_trims',
  'license_fee',
  'washing',
  'packaging_labelling_processing',
  'other',
  'total_quantity',
  'avg_price_per_unit',
  'stock_cost_price',
  'delivery_destination',
  'xs',
  'youth_s',
  's',
  'youth_m',
  'm',
  'youth_l',
  'l',
  'youth_xl',
  'xl',
  'xxl',
  'xxxl',
  'xxxxl',
  'xxxxxl',
];

export const ORDER_CONFIRMATION_REQUIRED_FIELDS = [
  'brand',
  'department',
  'pf_style_number',
  'factory_1',
  'sales_price',
  'cost_price',
  'transport_method',
  'country_of_production',
  'transport',
  'fabric_weight',
];

export const ORDER_CONFIRMATION_REQUIRED_FIELDS_FOR_SAVE = ['brand'];

export const BSOF_REQUIRED_FIELDS = [
  'date_ordered',
  'blank_supplier',
  'blank_type',
  'blank_color',
  'stock_cost_price',
  'stock_delivery_date',
  'stock_order_ref',
];

export const ORDER_CONFIRMATION_DROP_REQUIRED_FIELDS = [
  'description',
  'color',
  'factory_exit_date',
  'agreed_delivery_date',
];
export const BLANK_STOCK_ORDER_DROP_REQUIRED_FIELDS = [
  'date_ordered',
  'blank_supplier',
  'blank_type',
  'blank_color',
  'stock_cost_price',
  'stock_delivery_date',
];
export const FORM_RENDERER_DEFAULT_NAME = 'Formark';
export const OCF_HEADER_TITLE = 'Order Confirmation';
export const BSOF_SUBFORM_TITLE = 'BSO Drop';
export const BSOF_SUBFORM_NAME = 'bso_drop';
export const OCF_SUBFORM_TITLE = 'OC Drop';
export const OCF_SUBFORM_NAME = 'oc_drop';
export const BSOF_DROP_SIZES = [
  'xs',
  'youth_s',
  's',
  'youth_m',
  'm',
  'youth_l',
  'l',
  'youth_xl',
  'xl',
  'xxl',
  'xxxl',
  'xxxxl',
  'xxxxxl',
];
export const FIELDS_TO_REMOVE_FROM_OCF = [
  'date',
  'transport_for_brand',
  'selectedBrand',
  'unique_oc_no',
  'date_created',
  'createdOn',
  'modifiedOn',
];
export const FIELDS_TO_REMOVE_FROM_OCD = ['createdOn', 'modifiedOn'];
export const FIELDS_TO_REMOVE_FROM_BSOF = ['createdOn', 'modifiedOn'];
export const FIELDS_TO_REMOVE_FROM_BSOFDROP = ['loaded', 'original_stock_order_quantity'];

export const ORDER_CONFIRMATION_COMPLETE_STATUS = 2;
export const ORDER_CONFIRMATION_ASSIGNED_STATUS = 1;
export const ORDER_CONFIRMATION_INCOMPLETE_STATUS = 3;
export const ORDER_CONFIRMATION_DEFAULT_PAGE_SIZE = 50;
export const BLANK_STOCK_ORDER_ASSIGNED_STATUS = 1;
export const BLANK_STOCK_ORDER_UNASSIGNED_STATUS = 2;
export const BLANK_STOCK_ORDER_COMPLETED_STATUS = 3;

export const ACTIVITY_LOG_DEFAULT_PAGE_SIZE = 50;
export const TABLE_DEFAULT_PAGE_SIZE = 10;
export const FIELDS_TO_REMOVE_FROM_REPEATED_OC_DROP = [
  'id',
  'critical_path',
  'agreed_delivery_date',
  'factory_exit_date',
  'stock_total_quantity',
  'blank_garment',
  'total_quantity',
  'modifiedOn',
  'createdOn',
];
export const FIELDS_TO_REMOVE_FROM_REPEATED_OC_FORM = [
  'selectedBrand',
  'id',
  'unique_oc_no',
  'date_created',
  'uploaded_po_file',
  'modifiedOn',
  'createdOn',
];
export const FIELDS_TO_REMOVE_FROM_EDITTED_OC_FORM = [
  'author',
  'order_confirmation_drop',
  'modifiedOn',
  'createdOn',
];

export const CURRENCY_GBP = '£';
export const CURRENCY_EUR = '€';
export const CURRENCY_USD = '$';

export const COUNTRY_UK = 'uk';
export const COUNTRY_TURKEY = 'turkey';
export const COUNTRY_US = 'us';

export const DEFAULT_CURRENCY = 'GBP';

export const CURRENCY_SYMBOLS = {
  EUR: CURRENCY_EUR,
  [DEFAULT_CURRENCY]: CURRENCY_GBP,
  USD: CURRENCY_USD,
} as { [key: string]: string };

export const TRANSPORT_METHOD_FOB = 'fob';
export const TRANSPORT_METHOD_LANDED = 'landed';

export const ORDER_CONFIRMATION_FORM_PATH = '/orderconfirmation/new';
export const ORDER_CONFIRMATION_EDIT_FORM_PATH = '/orderconfirmation/edit';
export const UK_CRITICAL_PATH_TABLE_PATH = '/criticalpath/uk';
export const TURKEY_CRITICAL_PATH_TABLE_PATH = '/criticalpath/turkey';
export const ORDER_CONFIRMATION_AMEND_PATH = '/orderconfirmation/view';
export const ORDER_CONFIRMATION_DRAFT_PATH = '/orderconfirmation/view/draft';
export const BLANK_STOCK_ORDER_FORM_PATH = '/orderconfirmation/new/quantity';
export const ORDER_CONFIRMATION_FORM_EDIT_PATH = '/orderconfirmation/edit';
export const DISPATCHED_STOCK_PATH = '/dispatchedstock';

export const STATUS_MESSAGE_TYPES = {
  indeterminate: 'indeterminate',
  error: 'error',
  success: 'success',
  info: 'info',
};

//  TODO: Confirm what the defaults should be or whether this should be a configurable value too
export const TRANSPORT_METHOD_MARKUP_DEFAULT_FOB = '';
export const TRANSPORT_METHOD_MARKUP_DEFAULT_LANDED = '';

export const USER_ROLE_SUPER_USER = 'SUPER_USER';
export const USER_ROLE_ADMIN_USER = 'ADMIN_USER';
export const USER_ROLE_GENERAL_USER = 'GENERAL_USER';

export const CriticalPathStatus = {
  HIGHLIGHTED: 4,
  GROUNDED: 2,
  CANCELLED: 6,
  DELIVERED: 5,
  ASSIGNED: 1,
  CP_CANCELLED: 3,
  COMPLETE: 7,
};

export const OrderConfirmationStatus = {
  ASSIGNED: ORDER_CONFIRMATION_ASSIGNED_STATUS,
  COMPLETE: ORDER_CONFIRMATION_COMPLETE_STATUS,
  INCOMPLETE: ORDER_CONFIRMATION_INCOMPLETE_STATUS,
};

export const STOCK_REDIRECT_URL = '/stockmanagement/unassigned';

export const tableSortStatus = {
  USERS: 'usersTableSort',
  BRANDS: 'brandsTableSort',
  FACTORIES: 'factoriesTableSort',
  GROUPS: 'groupsTableSort',
  BLANK_STOCK_PROFILE: 'blankStockProfileTableSort',
  CRITICAL_PATH: 'criticalPathTableSort',
  DISPATCHED: 'dispatchedTableSort',
  GROUNDED: 'groundedTableSort',
  CABAGE: 'cabageTableSort',
  INVENTORY_UNASSIGNED: 'inventoryUnassignedTableSort',
  LIVE_ASSIGNED: 'liveAssignedTableSort',
};

export const CREATE_STOCK_DEDUCTIONS_COLUMNS = [
  'oc_id',
  'author',
  'assigned_user',
  'oc_createdOn',
  'oc_modifiedOn',
  'bsod_date_ordered',
  'bsod_stock_cost_price',
  'xs',
  'youth_s',
  's',
  'youth_m',
  'm',
  'youth_l',
  'l',
  'youth_xl',
  'xl',
  'xxl',
  'xxxl',
  'xxxxl',
  'xxxxxl',
];

export const CURRENCY_INPUT_PROPS = { step: '0.01', min: '0' };

export const TABLE_LIMIT_KEY = 'table_limit';

export const CriticalPathApprovals = {
  APPROVE: 'Approve',
  REJECT: 'Reject',
  RA: 'R/A',
};

export const OCFormFieldUnsetValues = {
  brand: -1,
  transport_method: 'Choose a brand...',
};

export const OCFormFieldsWithInvalidDefaults = ['transport_method'];

export const DESCRIPTION_COLUMN_PRESET_COLORS = [
  {
    name: 'Yellow',
    hexCode: '#FEF0C8',
  },
  {
    name: 'Green',
    hexCode: '#D1E7CF',
  },
  {
    name: 'Blue',
    hexCode: '#C7DDF0',
  },
  {
    name: 'Red',
    hexCode: '#F7C5C5',
  },
  {
    name: 'Purple',
    hexCode: '#D5CBE4',
  },
  {
    name: 'Default Grey',
    hexCode: 'transparent',
  },
];
